import { useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'

export const useIsBadScreenSize = () => {
  const theme = useTheme()

  const matchDown = useMediaQuery('(max-width:1556px)')
  const matcheUp = useMediaQuery(theme.breakpoints.up('lg'))

  if (matchDown && matcheUp) {
    return true
  }
  return false
}

export default useIsBadScreenSize
